























































































import Vue from 'vue';
import Component from 'vue-class-component';
import { AuthenticationModuleState } from '../types';
import { mapState } from 'vuex';
import LocalStorageService from '../services/localStorageService';

@Component({
  computed: {
    isDarkModeEnabled: function() {
      return this.$vuetify.theme.dark;
    },
    ...mapState<AuthenticationModuleState>('authenticationModule', {
      localUser: (state: AuthenticationModuleState) => state.localUser
    })
  }
})
export default class TopToolbar extends Vue {
  [x: string]: any; // TAB: Hack that silences TypeScript warnings about this.$vuetify
  private isShowingMenu = false;
  private localStorageService: LocalStorageService | null = null;

  public mounted(): void {
    this.localStorageService = new LocalStorageService();
  }

  public toggleMenu(): void {
    this.isShowingMenu = !this.isShowingMenu;
  }

  public logUserOut(): void {
    this.$store.dispatch('authenticationModule/logOut')
      .then(() => {
        if (this.$router.currentRoute.path !== '/') {
          this.$router.push({ path: '/' });
        }

        this.isShowingMenu = false;
      });
  }

  public toggleDarkMode(): void {
    this.$vuetify.theme.dark = !this.$vuetify.theme.dark;

    if (!this.localStorageService) {
      throw new Error('TopToolbar.toggleDarkMode: localStorageService is null or undefined');
    }

    this.localStorageService.setDarkModeEnabled(this.$vuetify.theme.dark);
  }
}

